import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';
import ProductImg from '../../img/jetPeel-products/Hero.png';
import Tools from '../../img/icons/tools.png';
import Gem from '../../img/icons/gem.png';
import Light from '../../img/icons/light.png';

const Header = ({ title, subtitle, text1, text2 }) => {
  // const [bigProductImg, setBigProductImg] = useState(bigProduct1);
  const [hoveredBenefit, setHoveredBenefit] = useState(null);
  const { t } = useTranslation();

  return (
    <header className="header flow">
      <div className="bg-gradient"></div>
      <div className="glow-orb orb-1"></div>
      <div className="glow-orb orb-2"></div>
      <div className="container">
        <div className="header-wrapper">

          <div className="header-image__container">
             <div className="product-wrapper">
              <img
                src={ProductImg}
                alt="product collection"
                className="big__product-img"
              />
            </div>


            {/* <img
              src={bigProductImg}
              alt="product collection"
              className="big__product-img"
            />

            <div className="header__thumbnails">
              {articles.map((image, index) => (
                <div key={index}>
                  <ProductCard
                    imgURL={image}
                    changeBigProductImage={(product) =>
                      setBigProductImg(product)
                    }
                    bigProductImg={bigProductImg}
                  />
                </div>
              ))}
            </div> */}
          </div>

          <div className="header__content">
            <p className="header__eyebrow">{t('header.subtitle')}</p>
            <h1 className="header__title">
              {t('header.heroTitle')}
            </h1>

            <p className="welcome-text">{t('header.welcome')}</p>

            <p className="header__lead">
              {t('header.lead')}
            </p>

            <ul className="header__benefits">
              {t('header.benefitsList', { returnObjects: true }).map((benefit, idx) => (
                <li key={idx} className="benefit-item">
                  <span className="checkmark"></span>
                  {benefit}
                </li>
              ))}
            </ul>

            <div className="header__actions">
              <a href="/contacts" className="btn-header btn-header-primary">
                {t('header.contact')}
              </a>
              <a href="/jetPeel" className="btn-header btn-ghost">
                {t('header.viewDevices')}
              </a>
            </div>
          </div>

          {/* <div className="header__content">
            <p className="header__subtitle">{subtitle}</p>
            <h1 className="header__title">{title}</h1>
            <div className="header__text">
              <p>{text1}</p>
              <p>{text2}</p>
            </div>
            <Button link="/contacts" label={t('header.contact')} />
          </div> */}

          
        </div>
        <div className="benefits">
          {t('header.cards', { returnObjects: true }).map((card, idx) => (
            <div
              key={idx}
              className={`benefit-card ${hoveredBenefit === idx ? 'hover-active' : ''}`}
              onMouseEnter={() => setHoveredBenefit(idx)}
              onMouseLeave={() => setHoveredBenefit(null)}
              style={{ '--animation-delay': `${[0, 0.1, 0.2][idx]}s` }}
            >
              <div className="benefit-icon">
                <img src={[Light, Tools, Gem][idx]} alt={card.title} />
              </div>
              <h3 className="benefit-title">{card.title}</h3>
              <p>{card.desc}</p>
              <div className="benefit-line"></div>
            </div>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
